import { Card, CardContent } from "../ui/card";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import {
  Bell,
  BellRing,
  Plus,
  Trash2,
  Play,
  Mail,
  Phone,
  Clock,
} from "lucide-react";

const AlertsTab = ({
  alerts,
  onCreateAlert,
  onCheckAlert,
  onDeleteAlert,
}) => {
  return (
    <>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-2xl font-bold text-foreground mb-2">
            Property Alerts
          </h2>
          <p className="text-muted-foreground">
            Get notified when new properties match your criteria
          </p>
        </div>
        <Button onClick={onCreateAlert} data-testid="new-alert-btn">
          <Plus className="w-4 h-4 mr-2" />
          New Alert
        </Button>
      </div>
      {alerts.length === 0 ? (
        <Card className="bg-card border-border p-12 text-center">
          <BellRing className="w-12 h-12 mx-auto text-muted-foreground mb-4" />
          <h3 className="text-lg font-semibold mb-2">No Alerts Set</h3>
          <p className="text-muted-foreground mb-4">
            Create an alert to get notified about new properties
          </p>
          <Button onClick={onCreateAlert}>
            <Plus className="w-4 h-4 mr-2" />
            Create Your First Alert
          </Button>
        </Card>
      ) : (
        <div className="space-y-4">
          {alerts.map((alert) => (
            <Card
              key={alert.id}
              className="bg-card border-border"
              data-testid={`alert-${alert.id}`}
            >
              <CardContent className="p-6">
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-2">
                      <h3 className="font-semibold text-lg text-foreground">
                        {alert.name}
                      </h3>
                      <Badge
                        variant={alert.is_active ? "default" : "secondary"}
                        className={
                          alert.is_active
                            ? "bg-emerald-500/15 text-emerald-500"
                            : ""
                        }
                      >
                        {alert.is_active ? "Active" : "Paused"}
                      </Badge>
                    </div>
                    <div className="flex flex-wrap gap-2 mb-3">
                      {alert.filters.city && (
                        <Badge variant="outline">{alert.filters.city}</Badge>
                      )}
                      {alert.filters.state && (
                        <Badge variant="outline">{alert.filters.state}</Badge>
                      )}
                      {alert.filters.min_price && (
                        <Badge variant="outline">
                          Min ${alert.filters.min_price.toLocaleString()}
                        </Badge>
                      )}
                      {alert.filters.max_price && (
                        <Badge variant="outline">
                          Max ${alert.filters.max_price.toLocaleString()}
                        </Badge>
                      )}
                      {alert.filters.min_beds && (
                        <Badge variant="outline">
                          {alert.filters.min_beds}+ beds
                        </Badge>
                      )}
                      {alert.filters.only_profitable && (
                        <Badge
                          variant="outline"
                          className="text-emerald-500"
                        >
                          Profitable only
                        </Badge>
                      )}
                    </div>
                    <div className="flex items-center gap-4 text-sm text-muted-foreground">
                      {alert.notify_email && (
                        <span className="flex items-center gap-1">
                          <Mail className="w-3 h-3" />{" "}
                          {alert.recipient_email || "Email"}
                        </span>
                      )}
                      {alert.last_triggered && (
                        <span className="flex items-center gap-1">
                          <Clock className="w-3 h-3" /> Last:{" "}
                          {new Date(
                            alert.last_triggered
                          ).toLocaleDateString()}
                        </span>
                      )}
                      {alert.matches_count > 0 && (
                        <span className="text-emerald-500">
                          {alert.matches_count} matches
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => onCheckAlert(alert.id)}
                      data-testid={`check-alert-${alert.id}`}
                    >
                      <Play className="w-4 h-4 mr-1" />
                      Check Now
                    </Button>
                    <Button
                      variant="ghost"
                      size="sm"
                      onClick={() => onDeleteAlert(alert.id)}
                    >
                      <Trash2 className="w-4 h-4 text-destructive" />
                    </Button>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
      <p className="text-xs text-muted-foreground mt-4 text-center">
        Email alerts are live via Resend.
      </p>
    </>
  );
};

export default AlertsTab;
